import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Api } from "../../../../helpers/Api";
import htmlDocx from "html-docx-js/dist/html-docx";
import { saveAs } from "file-saver";
import { nl2br } from "../../../../helpers/CommonFunction";

const styles = {
  container: {
    width: "900px",
    maxWidth: "900px",
    margin: "0 auto",
    clear: "both",
  },
  logoTable: {
    width: "1000px",
    margin: "0 auto",
    borderCollapse: "collapse",
    border: "none",
  },
  logoCell: {
    border: "none",
    padding: "10px",
    verticalAlign: "middle",
  },
  table: {
    width: "1000px",
    margin: "0",
    borderCollapse: "collapse",
  },
  cell: {
    border: "1px solid #000",
    padding: "5px",
    verticalAlign: "top",
    fontSize: "13px",
  },
  title: {
    border: "1px solid #000",
    padding: "5px",
    verticalAlign: "top",
    textAlign: "center",
    fontSize: "18px",
    fontWeight: "bold",
  },
  sectionTitle: {
    border: "1px solid #000",
    padding: "3px",
    fontSize: "14px",
    verticalAlign: "top",
    backgroundColor: "#f3f3f3",
    fontWeight: "bold",
  },
  largeBox: {
    border: "1px solid #000",
    padding: "5px",
    fontSize: "14px",
    verticalAlign: "top",
    height: "10px",
  },
  mediumBox: {
    border: "1px solid #000",
    padding: "5px",
    verticalAlign: "top",
    fontSize: "14px",
    height: "100px",
  },
  imageBox: {
    border: "1px solid #000",
    padding: "5px",
    verticalAlign: "top",
    height: "250px",
  },
  image: {
    // border: "1px solid #000",
    padding: "5px",
    verticalAlign: "top",
    height: "250",
    width:"300"
  },
  pageBreak: {
    marginTop: "30px",
    pageBreakBefore: "always",
  }
};

const NewIicReport = () => {

  const [data, setData] = useState(null);
  const parms = useParams();

  const wordFormat1 = () => {
    var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title></head><body>";
    var postHtml = 
    `</body>
      </html>
      <head>
        <meta charset="utf-8" />
        <style>
          @page {
            size: A4;
            margin: 0.5in;
          }

          body {
            font-family: Calibri, Arial, sans-serif;
          }

          table {
            border-collapse: collapse;
            width: 100%;
          }

          td, th {
            border: 1px solid #000;
            padding: 8px;
            vertical-align: top;
          }

          img {
            max-width: 100%;
            height: auto;
          }
        </style>
      </head>
    `;

    var html = preHtml + document.getElementById("page").innerHTML + postHtml;

    var blob = new Blob(['\ufeff', html], {
      type: 'application/msword'
    });

    var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);


    // var filename = data?.template?.name ? data?.template?.name + '.doc' : 'document.doc';
    var filename = 'IIC_Report.doc';

    var downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {

      downloadLink.href = url;
      downloadLink.download = filename;
      downloadLink.click();
    }

    document.body.removeChild(downloadLink);
  };
  
  const wordFormat = () => {
  const page = document.getElementById("page");

  const html = `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8" />
        <style>
          @page {
            size: A4;
            margin: 0.5in;
          }

          body {
            font-family: Calibri, Arial, sans-serif;
          }

          table {
            border-collapse: collapse;
            width: 100%;
          }

          td, th {
            border: 1px solid #000;
            padding: 8px;
            vertical-align: top;
          }

          img {
            max-width: 100%;
            height: auto;
          }
        </style>
      </head>
      <body>
        ${page.innerHTML}
      </body>
    </html>
  `;

  const blob = htmlDocx.asBlob(html);

  saveAs(blob, `${data?.template?.name}.docx`);
};



  const load = (id) => {
      Api.call(`/getReport/${id}`).then(post => { 
        setData(post)
      }).catch(console.log).finally(() => {
          console.log("data" ,data);
      });
  }

  useEffect(() => {
          if (data) {
              document.getElementById("oActivity").innerHTML = nl2br(data?.oActivity);
          }
      }, [data?.oActivity])

  useEffect(() => {
    if(parms.id !== 'undefined'){
      load(parms.id)
    }
  }, [parms.id])
  
  return (
    <>
    <div style={{ width: "55%" }} className='Form-buttons mt-1'>
         <button onClick={wordFormat} className='cancel mb-3'>Download</button>
      </div>
     
      <div id="page" style={styles.container}>
        <table style={styles.logoTable} align="center" border='0' cellSpacing='0' cellPadding='10'>
          <tbody>
            <tr>
              <td style={styles.logoCell} align='left'>
                <img src='https://events.chitkara.edu.in/images/logo2.png' alt="Logo" />
              </td>
              <td style={styles.logoCell} align="right">
                <img src='https://events.chitkara.edu.in/images/report-logo2.png' alt="Logo" />
              </td>
            </tr>
          </tbody>
        </table>
        <table style={styles.table}>
          <tbody>
            <tr>
              <th colSpan="6" style={styles.title}>
                IIC Activity Report
              </th>
            </tr>

            <tr>
              <td colSpan="2" style={styles.cell}>
                <strong>Title of Event:</strong>
              </td>
              <td colSpan="4" style={styles.cell}>{data?.template?.name}</td>
            </tr>

            <tr>
              <td style={styles.cell}>
                <strong>Date:</strong>
              </td>
              <td style={styles.cell}><b>From:</b>{data?.template?.start_date} <b>To:</b>{data?.template?.end_date}</td>
              <td style={styles.cell}>
                <strong>Duration (In hrs):</strong>
              </td>
              <td style={ styles.cell }>{data?.activityDuration}</td>
              <td style={styles.cell}>
                <strong>Mode:</strong>
              </td>
              <td style={styles.cell}>{data?.template?.location}</td>
            </tr>

            <tr>
              <td colSpan ="1" style={styles.cell}>
                <strong>Venue:</strong>
              </td>
              <td colSpan ="2" style={styles.cell}>{data?.template?.address_line_2 ? data?.template?.address_line_2 : `-`}</td>
              <td colSpan="2" style={styles.cell}>
                <strong>Activity Category:</strong>
              </td>
              <td style={styles.cell}>{data?.NC}</td>
            </tr>

            <tr>
              <td colSpan="6" style={styles.sectionTitle}>
                Objective of the Activity
              </td>
            </tr>

            <tr>
              <td colSpan="6" style={styles.largeBox}>
                <p style={{whiteSpace: 'pre-wrap'}}>{data?.objective}</p>
              </td>
            </tr>

            <tr>
              <td colSpan="2" style={styles.cell}>
                <strong>Activity Led By:</strong>
              </td>
              <td style={styles.cell}>{data?.leadBy}</td>

              <td colSpan="2" style={styles.cell}>
                <strong>Theme:</strong>
              </td>
              <td style={styles.cell}>{data?.programTheme}</td>
            </tr>

            <tr>
              <td colSpan="6" style={styles.sectionTitle}>
                Expert/Speaker Details
              </td>
            </tr>
            <tr>
              <td colSpan="2" style={styles.cell}>
                <strong>Name</strong>
              </td>
              <td style={styles.cell}>
                <strong>Designation</strong>
              </td>
              <td style={styles.cell}>
                <strong>Organization/Institution</strong>
              </td>
              <td colSpan="2" style={styles.cell}>
                <strong>Brief about Expert/Speaker</strong>
              </td>
            </tr>
            {data?.speakerDetails?.map((item) =>{
              return<tr>
              <td colSpan="2" style={styles.cell}>{item.Name}</td>
              <td style={styles.cell}>{item.Designation}</td>
              <td style={styles.cell}>{item.Organization}</td>
              <td colSpan="2" style={styles.cell}>{item.Brief}</td>
            </tr>
            })}

            <tr>
              <td colSpan="6" style={styles.sectionTitle}>
                Brief Description
              </td>
            </tr>

            <tr>
              <td colSpan="6" style={styles.largeBox}><p style={{whiteSpace: 'pre-wrap'}}>{data?.Description}</p></td>
            </tr>

            <tr>
              <td colSpan="6" style={styles.sectionTitle}>
                Details of Participant
              </td>
            </tr>

            <tr>
              <td style={styles.cell}>
                <strong>No. of Students</strong>
              </td>
              <td style={styles.cell}>{data?.participants}</td>

              <td style={styles.cell}>
                <strong>No. of Staff (Teaching/Non-Teaching)</strong>
              </td>
              <td style={styles.cell}>{data?.faculty}</td>

              <td style={styles.cell}>
                <strong>No. of External Participation</strong>
              </td>
              <td style={styles.cell}>{data?.participantsExternal}</td>
            </tr>

            <tr>
              <td colSpan="6" style={styles.sectionTitle}>
                Key Highlights
              </td>
            </tr>

            <tr>
              <td colSpan="6" style={styles.cell}>
                <p id="oActivity" style={{whiteSpace: 'pre-wrap'}}>{data?.oActivity}</p>
              </td>
            </tr>

            <tr>
              <td colSpan="6" style={styles.sectionTitle}>
                Outcome of the Activity
              </td>
            </tr>

            <tr>
              <td colSpan="6" style={styles.mediumBox}>
                {data?.outcomes}
              </td>
            </tr>

            <tr>
              <td colSpan="6" style={styles.sectionTitle}>
                Organizing Team Members Details
              </td>
            </tr>
            <tr>
              <th colSpan="2" style={styles.cell}>Name</th>
              <th style={styles.cell}>Designation</th>
              <th style={styles.cell}>Department</th>
              <th colSpan="2" style={styles.cell}>Role</th>
            </tr>
            {data?.OrganizingTeamDetails?.map((item)=>{
              return<tr>
              <td colSpan="2" style={styles.cell}>{item?.Name}</td>
              <td style={styles.cell}>{item?.Designation}</td>
              <td style={styles.cell}>{item?.Department}</td>
              <td colSpan="2" style={styles.cell}>{item?.Role}</td>
            </tr>})}

            <tr>
              <td style={styles.cell}>
                <strong>Pre Link:</strong>
              </td>
              <td colSpan="2" style={styles.cell}>{data?.preLink}</td>

              <td style={styles.cell}>
                <strong>Post Link:</strong>
              </td>
              <td colSpan="2" style={styles.cell}>{data?.postLink}</td>
            </tr>
          </tbody>
        </table>

        <div style={styles.pageBreak}>
          <table style={styles.table}>
            <tbody>
              <tr>
                <td colSpan="6" style={styles.sectionTitle}>
                  Photograph Screenshots
                </td>
              </tr>

              <tr>
                <th colSpan="3" style={styles.cell}>Pre Activity Screenshot</th>
                <th colSpan="3" style={styles.cell}>Post Activity Screenshot</th>
              </tr>

              <tr>
                <td colSpan="3" style={styles.imageBox}><img width={300} height={250} src={data?.preActivityScreenShort} alt="" /></td>
                <td colSpan="3" style={styles.imageBox}><img width={300} height={250} src={data?.postActivityScreenShort} alt="" /></td>
              </tr>

              <tr>
                <td colSpan="6" style={styles.sectionTitle}>
                  Event Images
                </td>
              </tr>

              <tr>
                <td colSpan="3" style={styles.imageBox}><img width={300} height={250} src={data?.EventsPhotos?.[0].imageUrl} alt="" /></td>
                <td colSpan="3" style={styles.imageBox}><img width={300} height={250} src={data?.EventsPhotos?.[1].imageUrl} alt="" /></td>
              </tr>

              <tr>
                <td colSpan="3" style={styles.imageBox}><img width={300} height={250} src={data?.EventsPhotos?.[2].imageUrl} alt="" /></td>
                <td colSpan="3" style={styles.imageBox}><img width={300} height={250} src={data?.EventsPhotos?.[3].imageUrl} alt="" /></td>
              </tr>

              <tr>
                <td colSpan="3" style={styles.imageBox}><img width={300} height={250} src={data?.EventsPhotos?.[4].imageUrl} alt="" /></td>
                <td colSpan="3" style={styles.imageBox}><img width={300} height={250} src={data?.EventsPhotos?.[5].imageUrl} alt="" /></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default NewIicReport;